// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const DeletePortfolioModalContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-deleteportfoliomodalcontainer" */ "./DeletePortfolioModalContainer")).then((bundle)=>{
        return {
            default: bundle.DeletePortfolioModalContainer
        };
    });
export const LazyDeletePortfolioModalContainer = /*#__PURE__*/ lazy(DeletePortfolioModalContainerLazyLoader);
